module.exports = " <ota-dialog [title]=\"title\" [rating]=\"rating\" [address]=\"address\" class=\"dialog-map\">\n     <div id=\"dialog-map\" class=\"dialog-map-padding\">\n        <act-google-map [latitude]=\"lat\" [longitude]=\"lng\" class=\"dialog-map\"></act-google-map>\n     </div>\n</ota-dialog> "


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modal/dialog-map/dialog-map.component.html
// module id = 1058
// module chunks = 22